import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    name: 'root',
    path: '/',
    redirect: {
      path: '/casinos'
    }
  },
  {
    path: '/casinos',
    name: 'casinos',
    component: () =>
      import('../views/BackOffice'),
    redirect: {
      name: 'manage-casinos'
    },
    children: [
      {
        name: 'manage-casinos',
        path: 'manage',
        component: () =>
          import('../views/casinos/CasinoList'),
      },
      {
        name: 'add-casino',
        path: 'manage/add',
        component: () =>
          import('../views/casinos/AddCasino'),
      },
      {
        name: 'edit-casino',
        path: 'manage/:id',
        component: () =>
          import('../views/casinos/EditCasino'),
      },
      {
        name: 'casino-integration-option-list',
        path: 'integration-options',
        component: () => import('../views/casinos/CasinoIntegrationOptionList')
      },
      {
        name: 'casino-integration-option-create',
        path: 'integration-options/create',
        component: () => import('../views/casinos/CasinoIntegrationOptionCreate')
      },
      {
        name: 'casino-integration-option',
        path: 'integration-options/:integrationOptionId',
        component: () => import('../views/casinos/CasinoIntegrationOption')
      },
      {
        name: 'casino-jurisdiction-list',
        path: 'jurisdictions',
        component: () => import('../views/masterdata/JurisdictionList')
      },
      {
        name: 'casino-jurisdiction-create',
        path: 'jurisdiction/create',
        component: () => import('../views/masterdata/JurisdictionCreate')
      },
      {
        name: 'casino-jurisdiction',
        path: 'jurisdiction/:jurisdictionId',
        component: () => import('../views/masterdata/Jurisdiction')
      },
    ]
  },
  {
    path: '/integrations',
    name: 'integrations',
    component: () =>
      import('../views/BackOffice'),
    redirect: {
      name: 'manage-integrations'
    },
    children: [
      {
        name: 'manage-integrations',
        path: 'manage',
        component: () =>
          import('../views/integrations/IntegrationList'),
      },
      {
        name: 'add-integration',
        path: 'manage/add',
        component: () =>
          import('../views/integrations/AddIntegration'),
      },
      {
        name: 'edit-integration',
        path: 'manage/:id',
        component: () =>
          import('../views/integrations/EditIntegration'),
      },
      {
        name: 'push-integration',
        path: 'push/:id',
        component: () =>
          import('../views/integrations/PushConfiguration'),
      },
      {
        name: 'integration-games',
        path: 'games',
        component: () =>
          import('../views/integrations/IntegrationGamesList'),
      },
      {
        name: 'integration-game',
        path: 'games/:integrationGameId',
        component: () => import('../views/integrations/IntegrationGame')
      }
    ]
  },
  {
    path: '/games',
    name: 'games',
    component: () =>
      import('../views/BackOffice'),
    redirect: {
      name: 'manage-games'
    },
    children: [
      {
        name: 'manage-games',
        path: 'manage',
        component: () =>
          import('../views/games/GamesList'),
      },
      {
        name: 'add-game',
        path: 'manage/add',
        component: () =>
          import('../views/games/AddGame'),
      },
      {
        name: 'edit-game',
        path: 'manage/:id',
        component: () =>
          import('../views/games/EditGame'),
      },
      {
        name: 'game-versions',
        path: 'versions',
        component: () =>
          import('../views/games/GamesVersionList'),
      },
      {
        name: 'add-version',
        path: 'versions/add',
        component: () =>
          import('../views/games/AddVersion'),
      },
      {
        name: 'edit-version',
        path: 'versions/:id',
        component: () =>
          import('../views/games/EditVersion'),
      },
      {
        name: 'copy-version',
        path: 'versions/copy/:id',
        component: () =>
          import('../views/games/CopyVersion'),
      },
      {
        name: 'game-integrations',
        path: 'integrations',
        component: () =>
          import('../views/games/GamesIntegrationList'),
      }
    ]
  },
  {
    path: '/bridges',
    name: 'bridges',
    component: () =>
      import('../views/BackOffice'),
    redirect: {
      name: 'manage-bridges'
    },
    children: [
      {
        name: 'manage-bridges',
        path: 'manage',
        component: () =>
          import('../views/bridges/BridgeList'),
      },
      {
        name: 'add-bridge',
        path: 'manage/add',
        component: () =>
          import('../views/bridges/AddBridge'),
      },
      {
        name: 'edit-bridge',
        path: 'manage/:id',
        component: () =>
          import('../views/bridges/EditBridge'),
      },
    ]
  },
  {
    path: '/support',
    name: 'support',
    component: () => import('../views/BackOffice'),
    redirect: { name: 'open-game-round-list' },
    children: [
      {
        name: 'open-game-round-list',
        path: 'open-game-rounds',
        component: () => import('../views/support/OpenGameRoundList')
      },
      {
        name: 'open-game-round',
        path: 'open-game-rounds/:casinoId/:openGameRoundId',
        component: () => import('../views/support/OpenGameRound')
      }
    ]
  },
  {
    path: '/reporting',
    name: 'reporting',
    component: () => import('../views/BackOffice'),
    redirect: {
      name: 'report-list'
    },
    children: [
      {
        path: 'reports',
        name: 'report-list',
        component: () => import('../views/reporting/ReportList')
      },
      {
        path: 'game-performance-reports',
        name: 'game-performance-report-list',
        component: () => import('../views/reporting/GamePerformanceReportList')
      },
      {
        path: 'casino-performance-reports',
        name: 'casino-performance-report-list',
        component: () => import('../views/reporting/CasinoPerformanceReportList')
      },
      {
        path: 'significant-events',
        name: 'significant-event-list',
        component: () => import('../views/reporting/SignificantEventList')
      },
      {
        path: 'significant-events/create',
        name: 'significant-event-create',
        component: () => import('../views/reporting/SignificantEventCreate')
      }
    ]
  },
  {
    path: '/cpv',
    name: 'cpv',
    component: () => import('../views/BackOffice'),
    redirect: {
      name: 'cpv-check-list'
    },
    children: [
      {
        path: 'checks',
        name: 'cpv-check-list',
        component: () => import('../views/cpv/CPVCheckList')
      },
      {
        path: 'checks/trigger',
        name: 'cpv-check-trigger',
        component: () => import('../views/cpv/CPVCheckTrigger')
      },
      {
        path: 'allowed-hashes',
        name: 'allowed-hash-list',
        component: () => import('../views/cpv/AllowedHashList')
      },
      {
        path: 'allowed-hashes/add',
        name: 'allowed-hash-add',
        component: () => import('../views/cpv/AllowedHashAdd')
      },
    ]
  },
  {
    path: '/logout',
    name: 'logout',
    component: () =>
      import('../views/Logout'),
  },
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: 'is-active',
  mode: 'history'
})

export default router
